import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import CategoryFilterModal from "../Category/CategoryNavModal";
import { Link } from "react-router-dom";

const BodyContent = ({
  parentCategory,
  isLoadingParent,
  subCategory,
  data,
}) => {
  const [showModal, setShowModal] = useState(false);
  const openFilterModal = () => setShowModal(true);
  const closeFilterModal = () => setShowModal(false);

  return (
    <>
      <div className="flex flex-col w-full mb-10">
        <div className="flex gap-1">
          <h1 className="font-bold text-4xl mb-12 break-before-all break-words">
            {data?.category ? data?.category?.name : data?.parentCategory?.name}
          </h1>
          <button
            onClick={openFilterModal}
            className="btn btn-primary md:hidden flex items-center gap-2"
          >
            <FontAwesomeIcon icon={faFilter} />
            <p>Filter</p>
          </button>
          {showModal && (
            <CategoryFilterModal
              subCategory={subCategory}
              parentCategory={parentCategory}
              isLoadingParent={isLoadingParent}
              showModal={showModal}
              closeFilterModal={closeFilterModal}
            />
          )}
        </div>
        <figure className="flex flex-col items-center md:flex-row gap-4">
          <div className="w-full md:w-[300px] shrink-0 rounded-lg flex justify-center items-center">
            <img
              src={
                data?.category?.imageUrl 
                  ? data?.category?.imageUrl
                  : "../../img/all_products_main.jpg"
              }
              alt="Product"
              loading="lazy"
              className="w-full h-auto rounded-lg"
            />
          </div>
          <figcaption className="flex flex-1 flex-col gap-3">
            <Link to={`/category/${data?.category?._id}`}>
              <h2 className="font-bold text-2xl">
                {data?.category?.name
                  ? data?.category?.name
                  : "Semiconductors Supplier"}
              </h2>
            </Link>
            <p className="text-left break-words break-before-all">
              {data?.category?.description
                ? data?.category?.description
                : " With a commitment to quality and excellence, Creatyea brings you semiconductors that power the forefront of technology. To enhance your shopping experience, we've implemented a user-friendly filter system. Simply select your desired category or subcategory to swiftly locate the semiconductor that aligns with your project requirements."}
            </p>
          </figcaption>
        </figure>
      </div>
    </>
  );
};
export default BodyContent;
